import React from 'react';
import PropTypes from 'prop-types';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { ListItemIcon, ListItemText, withStyles } from '@material-ui/core';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';
import Switch from 'components/forms/Switch';
import Counter from 'components/Counter';
import EmailConfigUpdate from './EmailConfigForms/EmailConfigUpdate';
import EmailConfigDelete from './EmailConfigForms/EmailConfigDelete';

const styles = () => ({
  menu: {
    '& ul': {
      '& li': {
        fontSize: '0.875rem',
        fontWeight: 600,
      },
      width: '256px',
    },
  },
  asDefaultText: {
    padding: '0 0.5rem',
  },
  defaultWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
});

const EmailConfigPopoverActions = ({
  classes,
  emailConfig,
  anchorEl,
  accountId,
  organizationId,
  handleDotsClose,
  handleDotsClick,
  changeIsPrimary,
  showNotification,
  totalEmailConfigs,
  totalDefaultEmailConfigs,
}) => (
  <React.Fragment>
    <div
      id={`popover-actions-${emailConfig.id}`}
      onClick={handleDotsClick}
      role="button"
      tabIndex="-1"
      onKeyDown={() => { }}
    >
      <MoreHorizIcon />
    </div>
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleDotsClose}
      className={classes.menu}
    >
      <MenuItem className="border-bottom">
        <div className={classes.defaultWrapper}>
          <Counter value={totalDefaultEmailConfigs} max={totalEmailConfigs} />
          <ListItemText className={classes.asDefaultText}>
            as Default
          </ListItemText>
        </div>
        <ListItemIcon>
          <Switch
            onChange={() => changeIsPrimary(emailConfig.id, emailConfig.is_primary)}
            checked={emailConfig.is_primary}
            controlled
          />
        </ListItemIcon>
      </MenuItem>
      <EmailConfigUpdate
        className="float-right"
        accountId={accountId}
        emailConfigId={emailConfig.id}
        initialValues={emailConfig}
        closeMenu={handleDotsClose}
      />
      <EmailConfigDelete
        accountId={accountId}
        organizationId={organizationId}
        emailConfigId={emailConfig.id}
        showNotification={showNotification}
      />
    </Menu>
  </React.Fragment>
);

EmailConfigPopoverActions.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  emailConfig: PropTypes.shape({}).isRequired,
  anchorEl: PropTypes.shape({}).isRequired,
  accountId: PropTypes.number.isRequired,
  organizationId: PropTypes.number.isRequired,
  handleDotsClose: PropTypes.func.isRequired,
  handleDotsClick: PropTypes.func.isRequired,
  changeIsPrimary: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  totalEmailConfigs: PropTypes.number.isRequired,
  totalDefaultEmailConfigs: PropTypes.number.isRequired,
};

export default withStyles(styles)(EmailConfigPopoverActions);
